<zv-dialog-wrapper [dataSource]="dwds">
  {{ content }}
  <ul>
    @for (name of itemNames; track name) {
      <li>{{ name }}</li>
    }
  </ul>
</zv-dialog-wrapper>
